import { ComponentProps, ReactNode } from "react";
import {
  ModalProvider as StyledReactModalProvider,
  BaseModalBackground,
} from "styled-react-modal";

type StyledReactModalProviderProps = ComponentProps<
  typeof StyledReactModalProvider
>;

type ModalProviderProps = {
  children: ReactNode;
  backgroundComponent?: StyledReactModalProviderProps["backgroundComponent"];
};

export { BaseModalBackground };

export const LegacyModalProvider = ({
  children,
  backgroundComponent = BaseModalBackground,
}: ModalProviderProps) => {
  return (
    <StyledReactModalProvider backgroundComponent={backgroundComponent}>
      {children}
    </StyledReactModalProvider>
  );
};
